import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { MaterialModule } from 'src/app/core/material.module';
import { AnnotationsService } from '../../../services/annotations.service';

@Component({
  selector: 'app-annotatio-type-comment-info',
  templateUrl: './annotatio-type-comment-info.component.html',
  styleUrls: ['./annotatio-type-comment-info.component.scss'],
  imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
      ]
})
export class AnnotatioTypeCommentInfoComponent implements OnInit {
  @Output() commentInformation = new EventEmitter();
  @Input() annotationData :any;

  public annotationAddComment = new FormGroup({

    comments: new FormControl('', [
      Validators.minLength(1),
      Validators.maxLength(256)
    ])
  });
  constructor(private annotationsService: AnnotationsService,) {
    this.annotationsService.eventEmitter.subscribe((d) => {
      if(d == 'sendData') {
        this.sendData();
      }

    })
  }

  ngOnInit(): void {
  }

  ngOnChanges(){

    this.setFormValue();
  }

  sendData(){
    this.commentInformation.emit(this.annotationAddComment.value)
  }
  setFormValue(){
    this.annotationAddComment.patchValue({
      comments: this.annotationData.comments
    })
  }
}
